export default {"src":"/_next/static/media/commercial-land-icon.8a1e3888.svg","height":110,"width":108,"blurWidth":0,"blurHeight":0};